import { withRouter } from 'react-router-dom'

import { AuthPage as AuthPageView } from './auth-page'

export const AuthPage = withRouter(AuthPageView)
export default AuthPage
